module.exports = __webpack_public_path__ + "static/media/_Orderinstruktion.ac2b1c48.scss";


//////////////////
// WEBPACK FOOTER
// ./src/routes/Cob/views/Citroneer/orderinstruktion/_Orderinstruktion.scss
// module id = 447
// module chunks = 0